import { IUserMailingSetting, SubscriptionsState } from "../type";

export function parseDealersToSubscriptions(
  users: IUserMailingSetting[],
): SubscriptionsState {
  const state: SubscriptionsState = {
    pledgeBook: [],
    orderPd: [],
    accountsReceivable: [],
    salesAndRemainsWeekly: [],
    salesAndRemainsMonthly: [],
  };

  users.forEach((u) => {
    if (u.pledgeBook) state.pledgeBook.push(u);
    if (u.orderPd) state.orderPd.push(u);
    if (u.accountsReceivable || u.overdAccountsReceivable)
      state.accountsReceivable.push(u);
    if (u.salesAndRemainsWeekly) state.salesAndRemainsWeekly.push(u);
    if (u.salesAndRemainsMonthly) state.salesAndRemainsMonthly.push(u);
  });

  return state;
}
